var React = require('react');

function Ee (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#1791ff","d":"M0 0h640v160H0z","key":0}),React.createElement("path",{"fill":"#000001","d":"M0 160h640v160H0z","key":1}),React.createElement("path",{"fill":"#fff","d":"M0 320h640v160H0z","key":2})]);
}

Ee.defaultProps = {"id":"flag-icons-ee","viewBox":"0 0 640 480"};

module.exports = Ee;

Ee.default = Ee;
